<template>
  <div>
    <div class="jackpot-section ts-py-32">
      <div class="ts-container ts-mx-auto ts-px-4 xl:ts-px-0">
        <a-skeleton :active="active" :loading="active" width="60px" :paragraph="{ rows: 15 }" />
        <div v-if="!active">
          <div class="ts-flex ts-justify-center">
            <div class="xl:ts-w-2/5 ts-max-w-screen-sm">
              <div class="section-header ts-text-center">
                <h2
                  class="section-title ts-capitalize ts-font-heading-font ts-text-heading-color ts-text-5xl ts-font-bold"
                >Lottery Jackpots</h2>
                <p
                  class="ts-block ts-mt-5 ts-text-para-color ts-font-robot ts-leading-relaxed ts-text-base"
                >
                  Choose from the Powerball, Mega Millions, Lotto or Lucky Day
                  Lotto and try for a chance to win a big cash prize
                </p>
              </div>
            </div>
          </div>
          <div
            class="ts-grid md:ts-grid-cols-2 ts-gap-12 ts-mt-12 ts-text-center"
            :class=" jackpot_lists.length > 2 ? 'lg:ts-grid-cols-3' : 'lg:ts-grid-cols-2'  "
          >
            <div
              v-for="(data, index) in jackpot_lists "
              :key="index"
              class="ts-w-full ts-pt-8 ts-pr-8 ts-pb-3 ts-pl-8 ts-shadow-rounded ts-border-b-2 ts-border-primary hover:ts-shadow-over ts-transition ts-duration-500 ts-ease-in-out ts-rounded-sm ts-relative"
            >
              <img
                class="ts-mx-auto ts-w-40 ts-h-40 ts-object-contain ts-object-center"
                :src="getImage(data)"
                @error="setNoImage"
                alt="image"
              />
              <span
                class="amount ts-block ts-font-bold ts-text-red-600 ts-text-3xl ts-mt-4 ts-py-2"
              >{{ price(data) }}</span>
              <h5
                class="title ts-font-medium ts-text-heading-color ts-font-heading-font ts-leading-tight ts-text-xl ts-m-0"
              >{{ data.game_setting }}</h5>
              <p
                class="next-draw-time ts-mt-8 ts-pb-6 ts-m-0 ts-text-lg ts-leading-relaxed ts-font-robot ts-text-heading-color ts-font-normal"
              >
                Next Draw :
                <span
                  id="remainTime1"
                >{{ convertDay(data.game_set_available.length > 0 ? data.game_set_available[0].result_date : '') }} days {{ data.game_set_available.length > 0 ? data.game_set_available[0].close_time : '' }}</span>
              </p>
              <!-- <a
                href="#0"
                class="
                cmn-btn 
                ts-uppercase 
                hover:ts-no-underline 
                ts-text-white 
                ts-bg-maincolor 
                ts-px-5 ts-py-3 
                ts-text-base 
                ts-rounded-full 
                ts-font-normal 
                ts-transition 
                ts-duration-500 
                ts-ease-in-out 
                ts-absolute 
                ts-mx-auto
                hover:ts-text-white 
                hover:ts-shadow-blue"
              >play now!</a> -->
            </div>
          </div>
          <div class="ts-w-full ts-mt-16 ts-text-center">
            <a
              href="#0"
              class="text-btn ts-underline ts-capitalize ts-font-normal ts-font-robot ts-text-base ts-text-heading-color hover:ts-text-maincolor"
            >Show all lotteries</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      active: true,
      jackpot_lists: [],
      no_image: require('@/assets/front/images/no_image.png')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.active = true
      this.$store
        .dispatch('front/jackpotSection/fetch', {
          include: 'game_lots,game_type',
          fields: {
            game_settings: 'game_setting_id,game_type_id,game_setting,game_logo'
          },
          today: true,
          page: -1
        })
        .then(response => {
          this.jackpot_lists = response.data
          this.active = false
        })
    },
    price(record) {
      if (record.game_type_id == 1) {
        return record.game_lots[0].odds
      } else {
        let lot = record.game_lots[0]
        return lot.odds * lot.unit_price
      }
    },
    convertDay(dateString) {
      if (dateString) {
        return moment(dateString, 'DD-MM-YYYY').format('DD')
      }
      return '00'
    },
    setNoImage(event){
      event.target.src = this.no_image
    },
    getImage(data){
      if(data.game_logo){
        return data.game_logo
      }else{
        return this.no_image
      }
    }
  }
}
</script>

<style lang="css" scoped>
.cmn-btn {
  right: 34%;
  top: 94%;
}
</style>
